module.exports = __webpack_public_path__ + "site/img/111.8d464a1e.jpg";